import { Base_Url } from "../../Base Url/BaseUrl";
import { postApiWithAuthenticated, getListWithAuthenticated} from "../../Api Method/ApiMethod";


const MasterJobEnquiryBaseUrl = `${Base_Url}/jobEnquiry`;


export const jobEnquiryList = async (params) => {
  let url = `${MasterJobEnquiryBaseUrl}/jobEnquiryList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};


export const addUpdateJobEnquiry = async (url = '', params) => {
    
  
    const res = await postApiWithAuthenticated(`${MasterJobEnquiryBaseUrl}${url}`, params);
    return res;
  };


export const changeJobEnquiryStatus = async (id) => {
  let url = `${MasterJobEnquiryBaseUrl}/changeJobEnquiryStatus?jobEnquiryKeyID=${id}`;
  const res = await getListWithAuthenticated(url);
  return res;
};
export const careerListWebsite = async (id) => {
  let url = `${MasterJobEnquiryBaseUrl}/careerListWebsite`;
  const res = await getListWithAuthenticated(url);
  return res;
};


export const GetCareerModelData = async (id) => {
    let url = `${MasterJobEnquiryBaseUrl}/GetCareerModel?careerKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };
export const positionLookupList = async (id) => {
    let url = `${MasterJobEnquiryBaseUrl}/positionLookupList`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };
export const getBlogForWebsite = async (id) => {
    let url = `${MasterJobEnquiryBaseUrl}/getBlogForWebsite?blogKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };


